import { api } from "./api";
import type { BackendTest, ReportPayload, Test } from "@/types";

function buildReportPayload(bt: BackendTest): ReportPayload {
  // Patient/partner name and DOB are stripped server-side, so anything left
  // in `extra` is safe to surface on the report.
  return {
    test_id: bt.test_id,
    accession_id: bt.accession_id ?? undefined,
    diagnostician_name: bt.diagnostician_name,
    abstinence_days: bt.abstinence_days != null ? String(bt.abstinence_days) : undefined,
    physician: bt.physician ?? undefined,
    created_at: bt.created_at,
    ...(bt.extra ?? {}),
  };
}

function backendTestToFrontend(bt: BackendTest, patientId: string): Test {
  const isReady = bt.status === "Complete";
  return {
    id: bt.id,
    patientId,
    status: isReady ? "ready" : "pending",
    label: "Semen Analysis",
    summary: isReady
      ? `Test ${bt.test_id} — complete`
      : `Test ${bt.test_id} — ${bt.status.toLowerCase()}`,
    createdAt: bt.created_at,
    reportPayload: buildReportPayload(bt),
  };
}

export async function getTest(testId: string): Promise<Test | null> {
  try {
    const bt = await api<BackendTest>(`/api/tests/${testId}`);
    return backendTestToFrontend(bt, "");
  } catch {
    return null;
  }
}
